/* eslint-disable @typescript-eslint/no-var-requires */
import React, { memo } from "react"
import { app } from "../appconfig"
import packageInfo from "../../package.json"
import i18n from "../i18n"

export const DefaultHeader = memo(() => (
    <nav className="navbar navbar-expand-md navbar-dark fixed-top bg-dark">
        <a className="navbar-brand" href="/">
            <img src="icons/xr-generator.svg" width="133" alt="XR-Generator" />
        </a>
        <ul className="navbar-nav me-auto hidden-on-mobile">
            <li className="nav-item">
                <a className="nav-link" href="https://www.rechnungen-digitalisieren.de/" target="_blank" rel="noopener noreferrer">
                    Weitere XRechnungstools
                </a>
            </li>
            <li className="nav-item">
                <a className="nav-link" href="https://nortal.com/de/?s=E-Rechnung" target="_blank" rel="noopener noreferrer">
                    Informationen zur E-Rechnung
                </a>
            </li>
            <li className="nav-item">
                <a className="nav-link" href="https://www.nortal.com/de/" target="_blank" rel="noopener noreferrer">
                    Nortal AG
                </a>
            </li>
        </ul>
    </nav>
))
DefaultHeader.displayName = "DefaultHeader"

export const DefaultFooter = memo(() => (
    <footer>
        <a href="https://www.nortal.com/de/privacy-notice-for-website-visitors/">Datenschutz</a> ·
        <a href="https://www.rechnungen-digitalisieren.de/impressum/">Impressum</a> ·
        <span style={{ margin: "0 1em" }}>
            {app} {packageInfo.version}
        </span>
    </footer>
))
DefaultFooter.displayName = "DefaultFooter"

export function DefaultCustomTemplate(setView: React.Dispatch<React.SetStateAction<React.JSX.Element | undefined>>, template: string) {
    if (!template) {
        throw new Error("missing template")
    }
    const langUrl = `./${i18n.language.toLowerCase()}/${template}`
    const url = `./${template}`
    let TemplateClass = undefined
    try {
        TemplateClass = require(`${langUrl}`)
    } catch {
        // intentionally left blank
    }
    if (!TemplateClass) {
        try {
            TemplateClass = require(`${url}`)
        } catch {
            // intentionally left blank
        }
    }
    if (!TemplateClass) {
        switch (template) {
            case "Header":
                TemplateClass = DefaultHeader
                break
            case "Footer":
                TemplateClass = DefaultFooter
                break
            default:
                TemplateClass = undefined
                break
        }
    } else {
        TemplateClass = TemplateClass.default
    }
    // React.createElement is needed because some paths return JSX functions and some JSX elements, this ensures we get elements
    setView(React.createElement(TemplateClass))
}
